import * as React from 'react'

import { useIntl } from '@grandvisionhq/state'

export const ReserveInStoreButton = ({ sku }: { sku: string }) => {
  const { getLabel } = useIntl()

  return (
    <button
      className="button button--primary button--outline socloz"
      data-socloz-service="reservation"
      data-socloz-product-id={sku}
      data-socloz-product-id_type="ean"
      data-t="btn-reserve-in-store"
    >
      {getLabel('products.actions.reserveInStore')}
    </button>
  )
}
